import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReportsService } from './reports.service';

export interface ILayoutConf {
  toolbarNav?: boolean;
  menu?: Menu[];
  menuFooter?: Menu[];
  updatedAt?: number;
  menuBanned?: string[];
  titlePage?: string;
}


@Injectable({
  providedIn: 'root'
})
export class MenuLayoutService {
  public layoutConf: ILayoutConf = {
    toolbarNav: true,
  };
  layoutConfSubject = new BehaviorSubject<ILayoutConf>(this.layoutConf);
  layoutConf$ = this.layoutConfSubject.asObservable();
  menu: Menu[] = [];
  menuFooter: Menu[] = [];
  excludeAll = 'organizationId,personId,others'; // SHOW ONLY MAIN MENU
  excludeFromOrganization = 'personId,others'; // SHOW ONLY ORGANIZATION MENU
  excludeFromPerson = 'organizationId,others'; // SHOW ONLY PERSON MENU
  excludeFromOthers = 'organizationId,personId';// SHOW ONLY OTHERS MENU

  constructor(
    private reportsService: ReportsService,
  ) {
    this.setMenu();
    this.setMenuFooter();
  }

  updateLayoutConfig() {
    this.setLayout({ updatedAt: new Date().getTime() });
  }

  setLayout(layoutConfSet: ILayoutConf) {
    this.layoutConf = { ...this.layoutConf, ...layoutConfSet };
    this.layoutConfSubject.next(this.layoutConf);
  }

  setMenuFooter() {
    this.menuFooter = [
      {
        type: 'divider'
      },
      {
        icon: 'logout',
        label: 'Sair',
        shortLabel: 'Sair',
        type: 'item',
        path: '/sessions/logout',
      },
    ];
    this.setLayout({ menuFooter: this.menuFooter });
  }

  setMenu() {
    this.menu = [
      {
        icon: 'business',
        label: 'Clientes',
        shortLabel: 'Clientes',
        type: 'item',
        showPath: false,
        path: '/organizacoes',
        activeType: 'FULL'
      },
      ...this.menuOrganizations(),
      {
        icon: 'person',
        label: 'Pacientes',
        shortLabel: 'Pacientes',
        type: 'item',
        showPath: false,
        path: '/pessoas',
        activeType: 'FULL',
        excludeByParam: this.excludeFromPerson,
      },
      ...this.menuPersons(),
      {
        icon: 'notes',
        label: 'Fila de exames',
        shortLabel: 'Fila exames',
        type: 'item',
        showPath: false,
        path: '/pessoas/exames-pendentes',
        activeType: 'PARTIAL',
        excludeByParam: this.excludeAll,
      },
      {
        icon: 'fact_check',
        label: 'Aprovações',
        shortLabel: 'Aprovações',
        type: 'item',
        showPath: false,
        path: '/pessoas/check-person-import',
        activeType: 'PARTIAL',
        excludeByParam: this.excludeAll,
      },
      {
        icon: 'blood_pressure',
        label: 'Import de pressão arterial',
        shortLabel: 'Pressão arterial',
        type: 'item',
        showPath: false,
        path: '/organizacoes/import-pressao-arterial',
        activeType: 'FULL',
        excludeByParam: this.excludeAll,
      },
      {
        icon: 'dynamic_feed',
        label: 'Outros',
        shortLabel: 'Outros',
        type: 'item',
        showPath: false,
        path: '/organizacoes/outros/notificacoes',
        activeType: 'FULL',
        excludeByParam: this.excludeAll,
      },
      ...this.menuOthers()
    ];
    this.setLayout({ menu: this.menu });
  }

  private menuOthers(): Menu[] {
    return [
      {
        icon: 'notifications',
        label: 'Notificações',
        shortLabel: 'Notificações',
        type: 'item',
        showPath: false,
        path: '/organizacoes/outros/notificacoes',
        activeType: 'FULL',
        idRequired: 'others',
      },
      {
        icon: 'import_export',
        label: 'Import / Export',
        shortLabel: 'Import  Export',
        type: 'item',
        showPath: false,
        path: '/organizacoes/outros/import-export-general',
        activeType: 'FULL',
        idRequired: 'others',
      },
      {
        icon: 'summarize',
        label: 'Report Template',
        shortLabel: 'Report Template',
        type: 'item',
        showPath: false,
        path: '/organizacoes/outros/report-template',
        activeType: 'FULL',
        idRequired: 'others',
      },
      {
        icon: 'toggle_on',
        label: 'Feature Flags',
        shortLabel: 'Feature Flags',
        type: 'item',
        showPath: false,
        path: '/organizacoes/outros/feature-flags',
        activeType: 'FULL',
        idRequired: 'others',
      },
      {
        icon: 'format_list_bulleted',
        label: 'Formulários',
        shortLabel: 'Formulários',
        type: 'item',
        showPath: false,
        path: '/pessoas/outros/formularios',
        activeType: 'FULL',
        idRequired: 'others',
      },
        {
          icon: 'translate',
          label: 'Tokens de localização do sistema',
          shortLabel: 'Tokens do sistema',
          type: 'item',
          showPath: false,
          path: '/organizacoes/outros/locale-tokens',
          activeType: 'FULL',
          idRequired: 'others',
        },
    ];
  }

  private menuPersons(): Menu[] {
    return [
      {
        icon: 'calculate',
        label: 'Riscos',
        shortLabel: 'Riscos',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/riscos',
        activeType: 'FULL'
      },
      {
        icon: 'monitor_heart',
        label: 'Exames',
        shortLabel: 'Exames',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/exames',
        activeType: 'FULL'
      },
      {
        icon: 'forward',
        label: 'Encaminhamentos',
        shortLabel: 'Encaminhamentos',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/encaminhamentos',
        activeType: 'FULL'
      },
      {
        icon: 'inventory',
        label: 'Questionários',
        shortLabel: 'Questionários',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/questionario',
        activeType: 'FULL'
      },
      {
        icon: 'history_edu',
        label: 'Antecedentes Clínicos',
        shortLabel: 'Antecedentes',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/antecedentes-clinicos',
        activeType: 'FULL'
      },
      {
        icon: 'local_activity',
        label: 'Vouchers',
        shortLabel: 'Vouchers',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/vouchers',
        activeType: 'FULL'
      },
      {
        icon: 'admin_panel_settings',
        label: 'Autenticação',
        shortLabel: 'Autenticação',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/authentications',
        activeType: 'FULL'
      },
      {
        icon: 'labs',
        label: 'Integração Labs',
        shortLabel: 'Integração Labs',
        type: 'item',
        showPath: false,
        idRequired: 'personId',
        path: '/pessoas/personId/laboratorios',
        activeType: 'FULL'
      },
    ];
  }

  private menuOrganizations(): Menu[] {
    return [
      {
        icon: 'corporate_fare',
        label: 'Cliente detalhes',
        shortLabel: 'Cliente detalhes',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId',
        activeType: 'FULL'
      },
      {
        icon: 'chat',
        label: 'Regras de notificações customizadas',
        shortLabel: 'Regras Notica...',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId/regras-notificacao-customizada',
        activeType: 'FULL'
      },
      {
        icon: 'settings_suggest',
        label: 'Regra de Recomendações',
        shortLabel: 'Regra de Recomenda',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId/recomendacoes',
        activeType: 'FULL',
      },
      {
        icon: 'rule_folder',
        label: 'Permissões',
        shortLabel: 'Permissões',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId/permissoes',
        activeType: 'FULL',
      },
      {
        icon: 'import_export',
        label: 'Import / Export',
        shortLabel: 'Import  Export',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId/import-export',
        activeType: 'FULL',
      },
      {
        icon: 'article',
        label: 'Termos',
        shortLabel: 'Termos',
        type: 'item',
        showPath: false,
        idRequired: 'organizationId',
        path: '/organizacoes/organizationId/termos',
        activeType: 'FULL',
      },
    ];
  }
}


export interface Menu {
  path?: string;
  showPath?: boolean;
  idRequired?: string;
  excludeByParam?: string;
  checkParent?: boolean;
  acl?: acl[],
  icon?: string;
  label?: string;
  shortLabel?: string;
  active?: boolean;
  activeType?: 'PARTIAL' | 'FULL'
  type: 'item' | 'submenu' | 'divider';
}

export type acl = 'HUMAN_RESOURCES' | 'BROKER' | 'HEALTH_OPERATOR' | 'GROUP';
